import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import "./hm-theme.css";

const LinkPackagesAndTests = ({ isOpen, onRequestClose, packageId }) => {
  const [packageDetails, setPackageDetails] = useState({});
  const [tests, setTests] = useState([]);
  const [mappedTests, setMappedTests] = useState([]);
  const [selectedTests, setSelectedTests] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchPackageDetails = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("data")).token;
        const response = await axios.get(`/api/package/${packageId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setPackageDetails(response.data || {});

        const mappedResponse = await axios.get(`/api/packagetestmapping/packageid=${packageId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setMappedTests((mappedResponse.data || []).map(test => test.testid));
      } catch (error) {
        handleError(error);
      }
    };

    if (isOpen && packageId) {
      fetchPackageDetails();
    }
  }, [isOpen, packageId]);

  useEffect(() => {
    setLoading(true);
    const fetchTests = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("data")).token;
        const response = await axios.get(`/api/labtest`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setTests(response.data || []);
        setLoading(false);
      } catch (error) {
        setLoading(false);
        handleError(error);
      }
    };
    fetchTests();
  }, []);

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  const handleTestSelection = (testId) => {
    setSelectedTests((prevSelected) =>
      prevSelected.includes(testId)
        ? prevSelected.filter((id) => id !== testId)
        : [...prevSelected, testId]
    );
  };

  const handleSaveMapping = async (e) => {
    e.preventDefault();
    if (selectedTests.length === 0) {
      toast.error("Please select at least one test to link.");
      return;
    }

    try {
      const token = JSON.parse(localStorage.getItem("data")).token;
      setLoading(true);
      await axios.post(
        `/api/packagetestmapping/create`,
        selectedTests.map((testId) => ({
          packageid: packageId,
          testid: testId,
        })),
        { headers: { Authorization: `Bearer ${token}` } }
      );
      toast.success("Tests mapped successfully");
      setLoading(false);
      onRequestClose();
    } catch (error) {
      handleError(error);
      setLoading(false);
    }
  };

  const availableTests = tests.filter((test) => !mappedTests.includes(test.id));

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered size="lg">
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">link</i>
          Link Tests to Package
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <Form onSubmit={handleSaveMapping}>
          <div className="mb-3 p-3 rounded-3 bg-light border">
            <span className="text-muted small d-block">Package Name:</span>
            <h6 className="fw-bold m-0" style={{ color: "#2f3a88" }}>{packageDetails.packagename || "—"}</h6>
          </div>

          <Form.Group className="mb-4">
            <Form.Label className="small fw-semibold">Select Tests to Add</Form.Label>
            {availableTests.length === 0 ? (
              <p className="text-muted text-center my-3">All available tests are already mapped to this package.</p>
            ) : (
              <div className="hm-test-dropdown p-3 border rounded-3" style={{ maxHeight: "300px", overflowY: "auto" }}>
                <Row>
                  {availableTests.map((test) => (
                    <Col key={test.id} md={6} className="mb-2">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`test-check-${test.id}`}
                          checked={selectedTests.includes(test.id)}
                          onChange={() => handleTestSelection(test.id)}
                          style={{ cursor: "pointer" }}
                        />
                        <label className="form-check-label small ms-1" htmlFor={`test-check-${test.id}`} style={{ cursor: "pointer" }}>
                          <strong>{test.testname}</strong> <span className="text-muted">({test.testCat?.categoryname || "General"})</span>
                        </label>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
            )}
          </Form.Group>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading || availableTests.length === 0}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>save</i>
              Save Mapped Tests ({selectedTests.length})
            </button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  );
};

export default LinkPackagesAndTests;
